import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import { config, LOG_OUT } from '../../constants';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import { Button, Input, message, Switch} from 'antd';
import { EditOutlined, } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';


export default class AddOrUpdateConfigComponent extends React.Component{

    constructor(props){
        super(props);

        const configID = this.props.match.params.configID
        const pageMode = configID ? "update" : "add";

        this.state = {
            pageMode: pageMode,
            configID: configID,
            config:{
                key:"",
                val:"",
                readOnly:false
            }
        }

        if(this.state.pageMode == "update"){axios.get(config.API_URL + "config/id/" + this.state.configID, {headers: authHeader()}).then(response => {

            var configData = response.data

            this.setState({config:configData})

        })}

    }

    addConfig = () => {
        const {key, val, readOnly} = this.state.config;

        const config = {key, val, readOnly};  

        AuthService.addConfig(config, authHeader).then(
            response => {
                let success = response.data;
                if (success) {
                    window.location = "/config-controller";
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)
                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )

    }
    
    updateConfig = () => {
        const {key, val} = this.state.config;

        const config = {key, val};  
        
        AuthService.updateConfig(config, authHeader, this.state.configID).then(
            response => {
                let success = response.data;
                if (success) {
                    window.location = "/config-controller";
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
    }


    handleInputChange = (e) => {
        const {name, value} = e.target

        this.setState(prevState => ({
            config: {
                ...prevState.config,
                [name]: value
            }
        }))

    }

    handleSwitchChange = (e) => {

        this.setState(prevState => ({
            config: {
                ...prevState.config,
                readOnly: !this.state.config.readOnly
            }
        }))

    }


    render(){
        
        return(

            <>
            <section className="user-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-user custom-ant-input-wrapper">
                                <div>
                                    <form method="POST" action="">

                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="text"
                                                   value={this.state.config.key}
                                                   name="key"
                                                   placeholder={i18n.t('config_input_key')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>
                                        
                                        <div className='form-box-user-input'>
                                            <TextArea
                                                name="val"
                                                value={this.state.config.val}
                                                placeholder={i18n.t('config_input_value')}
                                                onInput={this.handleInputChange}
                                                autoSize={{minRows: 7, maxRows: 7}}/>
                                        </div>

                                        {this.state.pageMode == "add" ? <div>
                                        <span className="ml-20 mr-20">{i18n.t('config_input_read_only')}</span>
                                        <Switch
                                                checked = {this.state.config.readOnly}
                                                onChange={this.handleSwitchChange}
                                                name="readOnly"
                                                checkedChildren={i18n.t('user_input_enabled')}
                                                unCheckedChildren={i18n.t('user_input_disabled')}
                                            />
                                        </div> : <></>}

                                        {this.state.pageMode == "update" && this.state.config.readOnly ? <></> : <Button
                                            className="custom-button"
                                            type="button"
                                            onClick={this.state.pageMode == "update" ? this.updateConfig : this.addConfig}
                                            >
                                            {this.state.pageMode == "update" ? i18n.t('update_config') : i18n.t('add_config')}
                                        </Button>}

                                        </form>
                                        
                                                                           
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            
            </>
            
        );

    }

}